@for (notification of legacyNotifications; track $index) {
  @if (notification.title.length > 0 || notification.description.length > 0) {
    <p-message class="notification-container" [severity]="mapLegacyColor(notification.color)" [closable]="notification.closable" [attr.data-testid]="'notification-container'">
      @if (notification.title.length > 0) {
        <p><b>{{ notification.title }}</b></p>
      }
      @if (notification.description.length > 0) {
        <div [innerHtml]="notification.description"></div>
      }
    </p-message>
  }
}

@for (notification of pimNotifications; track notification.id) {
  @if (notification.title.length > 0 || notification.message) {
    <p-message class="notification-container" [severity]="mapPimColor(notification.color)" [attr.data-testid]="'notification-container'">
      @if (notification.title.length > 0) {
        <p><b>{{ notification.title }}</b></p>
      }
      @if (notification.message) {
        <div [innerHtml]="notification.message"></div>
      }
    </p-message>
  }
}
